/**
 * @generated SignedSource<<c00e1bb883ee72f987e9b941097c27bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmployeeEditDeleteMutation$variables = {
  id: string;
};
export type EmployeeEditDeleteMutation$data = {
  readonly employee: {
    readonly delete: boolean;
  } | null;
};
export type EmployeeEditDeleteMutation = {
  response: EmployeeEditDeleteMutation$data;
  variables: EmployeeEditDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "EmployeeMutation",
    "kind": "LinkedField",
    "name": "employee",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delete",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeEditDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeeEditDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f4a6441188d58709ff93c9684821b5b4",
    "id": null,
    "metadata": {},
    "name": "EmployeeEditDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeEditDeleteMutation(\n  $id: ID!\n) {\n  employee(id: $id) {\n    delete\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c5fac300f37276886d264b00cc7e4bf";

export default node;
